<template>
  <el-row>
    <div class="borderBottom mt40 pb30 flex al-cn">
      <div class="commonTitle">비즈니스통역/여행가이드/기사</div>
      <el-dropdown class="mlr40">
        <div class="el-dropdown-link">
          {{ cityName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div @click="regionClick(item)" v-for="(item,index) in regionList" :key="index">
            <el-dropdown-item>{{ item.name }}</el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <div class="el-dropdown-link">
          {{ typeName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div @click="industryClick(item)" v-for="(item,index) in industryList" :key="index">
            <el-dropdown-item>{{ item.name }}</el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
        class="table" ref="filterTable" :data="tableData" style="width: 100%"
        :header-cell-style="{backgroundColor:'#F3F4F8'}" @row-click="talentDetails">
      <el-table-column label="도시">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.talentsCitys" :key="index">
            {{ item.name }}
            <span v-if="scope.row.talentsCitys && (index + 1 < scope.row.talentsCitys.length)">,</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="이름" width="180"></el-table-column>
      <el-table-column prop="gender" label="성별"></el-table-column>
      <el-table-column label="업종">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.talentsTypes" :key="index">
            {{ item.name }}
            <span v-if="scope.row.talentsTypes && (index + 1 < scope.row.talentsTypes.length)">,</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="일당"></el-table-column>
      <el-table-column prop="exp" label="근무경력"></el-table-column>
      <el-table-column prop="sketch" label="키워드" show-overflow-tooltip></el-table-column>
      <el-table-column label="클릭" width="100">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="text"
              @click="talentDetails(scope.row)">
            더보기
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="Talent-list">
      <Talent-list
          @detailsClick="talentDetails"
          v-for="(item,index) in tableData"
          :key="index"
          :item="item"/>
    </div>
    <div class="flex ju-cn mt20 mb40">
      <pagination
          class="pagination"
          background
          :total="total"
          layout="prev, pager, next"
          :page.sync="queryParams.page"
          :limit="15"
          @pagination="talentsListApi"
      />
    </div>
    <su-dialog :item="personnelDetails" v-if="personnelInformation" @close="personnelInformation = false"/>
  </el-row>
</template>
<script>

import {areaList, getIndustryList, talentsDetail, talentsListApi} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      personnelInformation: false,
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          tag: '家'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          tag: '公司'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          tag: '家'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          tag: '公司'
        }],
      queryParams: {
        typeId: '',
        cityId: '',
        page: 1,
        limit: 15
      },
      total: 0,
      personnelDetails: {},
      typeName: '업종', // 语种
      industryList: [], // 语种列表
      cityName: '도시', // 城市
      regionList: [], //地区列表
    }
  },
  created() {

  },
  mounted() {
    this.talentsListApi() // 获取人员列表
    this.getIndustryList() // 获取语种列表
    this.areaList() // 获取地区列表
  },
  methods: {
    // 地区点击
    regionClick(e) {
      this.queryParams.cityId = e.city_id
      this.cityName = e.name
      this.talentsListApi()
    },
    // 语种点击
    industryClick(e) {
      this.queryParams.typeId = e.type_id
      this.typeName = e.name
      this.talentsListApi()
    },
    // 获取地区列表
    areaList() {
      areaList().then(res => {
        if (res.status == 200) {
          var list = [{value: 0, text: '전부', type_id: 0, name: '전부'}];
          res.data.list.forEach(item => {
            item.value = item.type_id
            item.text = item.name
          })
          this.regionList = [...list, ...res.data.list];
        }
      })
    },
    // 获取语种列表
    getIndustryList() {
      // 获取语种列表
      getIndustryList().then(res => {
        if (res.status == 200) {
          var list = [{value: 0, text: '전부', id: 0, name: '전부'}];
          res.data.list.forEach(item => {
            item.value = item.id
            item.text = item.name
          })
          this.industryList = [...list, ...res.data.list];
        }
      })
    },
    // 人员详情
    talentDetails(e) {
      talentsDetail({
        talentsId: e.talents_id
      }).then(res => {
        if (res.status == 200) {
          this.personnelDetails = res.data.detail
          this.personnelInformation = true
        }
      })
    },
    // 人才列表
    talentsListApi() {
      talentsListApi(this.queryParams).then(res => {
        if (res.status === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.list.total
        }
      })
    },
  }
}
</script>


<style lang="scss">

@media (min-width: 750px) {
  .Talent-list {
    display: none;
  }
}

@media (max-width: 750px) {
  .table {
    display: none;
  }
}
</style>
